import axios, { AxiosHeaders } from "axios";

const FronteggClient = axios.create({
  baseURL: import.meta.env.VITE_FRONTEGG_BASEURL,
  timeout: 15000,
});

FronteggClient.interceptors.request.use((request) => {
  const token = localStorage.getItem("carbon0.accessToken");

  const headers = AxiosHeaders.from(request.headers);

  headers.set("Accept", "application/json");

  if (!headers.get("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  request.headers = headers;
  return request;
});

FronteggClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // handleAuthError();
      // window.location.href = "/account/login";
    }

    return Promise.reject(error);
  }
);

export default FronteggClient;
